import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { defaultLanguage } from 'constants'
import { getLanguageFromHost } from 'helper'

import resources from './locales'

const language = getLanguageFromHost() || defaultLanguage

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    fallbackLng: defaultLanguage,

    interpolation: {
      escapeValue: false
    }
  })

export default i18n
